import { render, staticRenderFns } from "./WidgetStats.vue?vue&type=template&id=5ea8e869&scoped=true&"
import script from "./WidgetStats.vue?vue&type=script&lang=js&"
export * from "./WidgetStats.vue?vue&type=script&lang=js&"
import style0 from "./WidgetStats.vue?vue&type=style&index=0&id=5ea8e869&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea8e869",
  null
  
)

export default component.exports